import {
  EyeOutlined,
  HeartOutlined,
  MessageOutlined,
  UserOutlined,
  CheckCircleOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { Avatar, Modal, Typography, Tag, Divider, Space } from "antd";
import React, { useEffect, useState } from "react";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import moment from "moment";

const { Text, Title, Paragraph } = Typography;

const ViewAPost = ({ isOpen, setIsOpen, setLoading = () => { }, postId }) => {
  const { request } = useRequest();
  const [post, setPost] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const fetchPost = (id) => {
    setLoading(true);
    request({
      url: `${apiPath.getPost}/${id}`,
      method: "GET",
      onSuccess: (res) => {
        setPost(res.data);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    if (isOpen && postId) {
      fetchPost(postId);
    }
  }, [isOpen, postId]);

  const closeModal = () => {
    setPost(null);
    setExpanded(false);
    setIsOpen(false);
  };

  if (!post) return null;

  return (
    <Modal
      open={isOpen}
      footer={null}
      onCancel={closeModal}
      centered
      width={450}
      closeIcon={<span style={{ fontSize: 18 }}>×</span>}
    >
      {/* 🔹 MEDIA */}
      <div className="post-view">
        {/* ================= MEDIA ================= */}
        <div className="post-media">
          {post?.mediaType === "video" ? (
            <video
              src={post?.mediaUrl}
              controls
              poster={post?.thumbnailUrl}
              className="post-video"
            />
          ) : (
            <img src={post?.mediaUrl} alt="post" className="post-image" />
          )}
        </div>

        {/* ================= STATS ================= */}
        <div className="post-stats">
          <Space size="large">
            <span>
              <EyeOutlined /> {post?.views || 0}
            </span>
            <span>
              <HeartOutlined /> {post?.totalLike || 0}
            </span>
            <span>
              <MessageOutlined /> {post?.totalComments || 0}
            </span>
          </Space>
        </div>

        {/* ================= DETAILS ================= */}
        <div className="post-details">
          {/* USER */}
          <div className="post-user">
            <Avatar
              size={45}
              icon={<UserOutlined />}
              src={post?.userDetails?.avatar}
            />
            <div>
              <Text strong>{post?.userDetails?.name || "Unknown User"}</Text>
            </div>
          </div>

          {/* CAPTION */}
          <Title level={5}>{post?.caption}</Title>

          {/* DESCRIPTION */}
          {post?.description && (
            <Paragraph className="post-description">
              {expanded
                ? post?.description
                : `${post?.description?.slice(0, 120)}${post?.description?.length > 120 ? "..." : ""
                }`}
              {post?.description?.length > 120 && (
                <Text
                  className="read-more"
                  onClick={() => setExpanded(!expanded)}
                >
                  {expanded ? "Show less" : "Read more"}
                </Text>
              )}
            </Paragraph>
          )}

          {/* HASHTAGS */}
          {post?.hashtags?.length > 0 && (
            <div className="post-section">
              <h4>Hash-Tags</h4>
              <Space wrap>
                {post?.hashtags?.map((tag) => (
                  <Tag key={tag} color="blue">
                    #{tag}
                  </Tag>
                ))}
              </Space>
            </div>
          )}

          {/* META INFO */}
          <div className="post-meta-grid">
            <div>
              <h4>Visibility</h4>
              <Tag color={post?.visibility === "private" ? "red" : "green"}>
                {post?.visibility}
              </Tag>
            </div>

            <div>
              <h4>Status</h4>
              <Tag
                color={
                  post?.status === "active"
                    ? "green"
                    : post?.status === "flagged"
                      ? "red"
                      : "orange"
                }
              >
                {post?.status}
              </Tag>
            </div>

            <div>
              <h4>Category</h4>
              <Tag color="purple">{post?.categoryDetails?.name || "N/A"}</Tag>
            </div>
            <div>
              <h4>Ball Type</h4>
              <Tag color="purple">{post?.ballType || "N/A"}</Tag>
            </div>
            <div>
              <h4>Skill Type</h4>
              <Tag color="purple">{post?.skillType || "N/A"}</Tag>
            </div>
            <div>
              <h4>Clip Type</h4>
              <Tag color="purple">{post?.clipType || "N/A"}</Tag>
            </div>
          </div>

          {/* FLAGS */}
          <div className="post-flags">
            {post?.isFeatured && (
              <Tag icon={<StarOutlined />} color="gold">
                Featured
              </Tag>
            )}
            {post?.isReviewed && (
              <Tag icon={<CheckCircleOutlined />} color="green">
                Reviewed
              </Tag>
            )}
          </div>

          {/* DATES */}
          <div className="post-dates">
            <p>
              Created: {moment(post?.created_at).format("DD MMM YYYY, hh:mm A")}
            </p>
            <p>
              Updated: {moment(post?.updated_at).format("DD MMM YYYY, hh:mm A")}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewAPost;
